import { clsx } from 'clsx'

interface Props {
	className?: string
}

const VerticalDivider = ({ className }: Props) => (
	<div class={clsx('w-px bg-brightBackground', className)} />
)

export { VerticalDivider }
